export default __webpack_public_path__ + "static/media/shrutiFsharp.45250b91.wav";